import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { postGenerateWeatherNews } from 'store/thunks';
import * as Yup from "yup";

interface ModalGenerateWeatherNewsProps {
    isOpen: boolean;
    listPlace: { label: string, value: string }[];
    onRefresh?: () => void,
    onClose?: () => void,
}

const ModalGenerateWeatherNews: React.FC<ModalGenerateWeatherNewsProps> = ({
    isOpen, listPlace, onRefresh, onClose
}) => {
    const { t } = useTranslation();

    const [isGenerating, setIsGenerating] = useState<boolean>(false);

    const handleClose = () => {
        onClose && onClose();
        formik.setValues({
            city_name: '',
        });
        formik.setErrors({});
    }

    // Update: correct according to available thunk
    const handleSubmit = async (values: any) => {
        try {
            if (isGenerating) return;
            setIsGenerating(true);
            const request = {
                city_name: values?.city_name || '',
            };
            const response: any = await postGenerateWeatherNews({});
            setIsGenerating((_prev) => false);
            if (response?.code === 200) {
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                onRefresh && onRefresh();
            } else {
                toast(`${response || ""}`, CONFIG_OPTION_TOAST_ERROR);
            }

        } catch (error: any) {
            setIsGenerating((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        city_name: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            city_name: '',
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true,
    });

    return (
        <>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                scrollable={false}
            >
                <ModalHeader toggle={handleClose}>
                    <>{t("Generate Weather News")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div className="card-body mt-0 pb-1">
                                <Row>
                                    <Col sm={12} className='mt-3 mb-1'>
                                        <LabelWrapper label={t('City Name')} isShow={true}>
                                            <DropdownOption
                                                name="city_name"
                                                dataList={listPlace || []}
                                                placeholder={`${t("City Name")}...`}
                                                className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                                classNamePrefix="name-prefix"
                                                initialValue={listPlace?.find((item: any) => item?.value === formik?.values?.city_name) || null}
                                                onChangeSelect={(e: any) => {
                                                    formik.setFieldValue('city_name', e?.value);
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={12} className='mt-4'>
                                        <div className='w-100 d-flex justify-content-end align-items-center gap-4'>
                                            <button
                                                className="btn btn-primary rounded-pill"
                                                type="submit"
                                                disabled={isGenerating || !formik?.values?.city_name}
                                                style={{ width: '160px' }}
                                            >
                                                {isGenerating ? <span style={{ transform: 'translateY(1px)' }}><Spinner size="sm" /></span> : <></>}
                                                <span className="ms-1">{t("Generate News")}</span>
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default React.memo(ModalGenerateWeatherNews);

